import type { ShareProvider } from '@pressreader/social-types';

import { MODULE_NAME } from '../../constants';

export const implementedShareProviders: ShareProvider[] = [
    'copyUrl',
    'shareFacebook',
    'shareTwitter',
    'shareeMail',
    'evernote',
    'onenote',
    'shareInstapaper',
];

export const STORE_SECTION_NAME = MODULE_NAME + '/issues';
